/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Social profile URLs shown as icons in the email footer. Only configured networks are rendered; when none are set the social row is omitted entirely.
 * @export
 * @interface TenantSocialLinks
 */
export interface TenantSocialLinks {
    /**
     * 
     * @type {string}
     * @memberof TenantSocialLinks
     */
    facebook?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantSocialLinks
     */
    twitter?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantSocialLinks
     */
    instagram?: string;
    /**
     * 
     * @type {string}
     * @memberof TenantSocialLinks
     */
    linkedin?: string;
}

/**
 * Check if a given object implements the TenantSocialLinks interface.
 */
export function instanceOfTenantSocialLinks(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TenantSocialLinksFromJSON(json: any): TenantSocialLinks {
    return TenantSocialLinksFromJSONTyped(json, false);
}

export function TenantSocialLinksFromJSONTyped(json: any, ignoreDiscriminator: boolean): TenantSocialLinks {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'facebook': !exists(json, 'facebook') ? undefined : json['facebook'],
        'twitter': !exists(json, 'twitter') ? undefined : json['twitter'],
        'instagram': !exists(json, 'instagram') ? undefined : json['instagram'],
        'linkedin': !exists(json, 'linkedin') ? undefined : json['linkedin'],
    };
}

export function TenantSocialLinksToJSON(value?: TenantSocialLinks | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'facebook': value.facebook,
        'twitter': value.twitter,
        'instagram': value.instagram,
        'linkedin': value.linkedin,
    };
}

